import useConfirm from "@/shared/atoms/useConfirm";
import useCommon from "@/shared/hooks/useCommon";
import { useLocation } from "react-router-dom";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

const Confirm = () => {
  const { pathname } = useLocation();
  const isKiosk = pathname.startsWith("/kiosk");
  const [confirm, setConfirm] = useConfirm();
  const t = useCommon();
  return (
    <Modal
      width={{ _: "95%", md: isKiosk ? "85rem" : "40rem" }}
      zIndex={999999999999}
      show={confirm !== null}
      onExit={() => setConfirm(null)}
    >
      <div className="mb-[1rem] text-[2rem]" style={{ marginTop: isKiosk ? "4rem" : "" }}>
        {isKiosk && t("kioskBackText")} {confirm?.message}
      </div>
      <div className="flex gap-4">
        <Button
          size={isKiosk ? "large" : undefined}
          as="button"
          onClick={() => {
            confirm?.cb();
            setConfirm(null);
          }}
        >
          {t("yes")}
        </Button>
        <Button
          size={isKiosk ? "large" : undefined}
          variant="secondary"
          as="button"
          onClick={() => setConfirm(null)}
        >
          {t("cancel")}
        </Button>
      </div>
    </Modal>
  );
};

export default Confirm;
